module.exports = "/_next/static/images/icon2-5e7a801fa69573eec749a46640523d47.png";